import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  postToWalmartFormValues: [],
  postToWalmartFormErrors: [],
};

export const walmartSlice = createSlice({
  name: 'walmart',
  initialState,
  reducers: {
    updatePostToWalmartFormValues: (state, action) => {
      const { productId, formData } = action.payload;
      const foundFormIndex = state.postToWalmartFormValues?.findIndex(
        (formValueItem) => formValueItem?.productId === productId
      );
      if (foundFormIndex === -1) return;
      let nextPostToWalmartFormValues = state.postToWalmartFormValues;
      nextPostToWalmartFormValues[foundFormIndex] = {
        productId,
        data: formData,
      };

      state.postToWalmartFormValues = nextPostToWalmartFormValues;
    },
    setPostToWalmartFormValues: (state, action) => {
      state.postToWalmartFormValues = action.payload;
    },
    setPostToWalmartFormErrors: (state, action) => {
      if (action.payload?.length === 1) {
        const foundIndex = state.postToWalmartFormErrors?.findIndex(
          (item) => item?.rivirProductId === action.payload?.[0]?.rivirProductId
        );
        if (foundIndex !== -1)
          state.postToWalmartFormErrors[foundIndex] = action.payload?.[0];
        else state.postToWalmartFormErrors = action.payload;
      } else state.postToWalmartFormErrors = action.payload;
    },

    clearAllPostToWalmartState: (state, action) => {
      state.postToWalmartFormErrors = [];
      state.postToWalmartFormErrors = [];
    },
  },
});

const selectPostToWalmartSlice = (state) => state['walmart'];

const selectPostToWalmartFormValues = (state) =>
  state['walmart']['postToWalmartFormValues'];

const selectPostToWalmartFormErrors = (state) =>
  state['walmart']['postToWalmartFormErrors'];

export {
  selectPostToWalmartFormValues,
  selectPostToWalmartSlice,
  selectPostToWalmartFormErrors,
};

export const {
  updatePostToWalmartFormValues,
  setPostToWalmartFormValues,
  setPostToWalmartFormErrors,
  clearAllPostToWalmartState,
} = walmartSlice.actions;

export default walmartSlice.reducer;
